import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, Form, Modal } from "react-bootstrap";
import { AiOutlineCloseCircle } from "react-icons/ai";
import axios from "../axios";
import { useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { Zoom } from "react-reveal";
import ImageSuperMarket from "./ImageSuperMarket";
import Currency from "./Currency";
import Price from "./Price";
import PriceBadge from "./PriceBadge";
import { getImageUrl } from "../utils/media";

function InStayShopCartPost({ item, theme, canOrder }) {
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [count, setCount] = useState(1);
  const [comment, setComment] = useState("");
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const queryClient = useQueryClient();
  const currency = localStorage.getItem("currency");
  const { t } = useTranslation();
  const lang = sessionStorage.getItem("lang");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCartClose = () => setShowCart(false);
  const handleCartShow = () => setShowCart(true);

  const handleIncrease = () => {
    setCount((prev) => (prev <= 1 ? 1 : prev - 1));
  };
  const handleDecrease = () => {
    setCount((prev) => prev + 1);
  };

  const addToCart = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(
        `/${room_uuid}/in-stay-shop/order/order-item`,
        {
          product_id: item.id,
          quantity: count,
          comment: comment?.trim() || "",
        },
        {
          headers: {
            lang: lang,
          },
        },
      )
      .then(() => {
        setLoading(false);
        queryClient.invalidateQueries("checkout");
        setComment("");
        setCount(1);
        handleCartClose();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  console.log(item, "item");

  return (
    <>
      <Zoom>
        <div className="add-cart-post new v2">
          <div className="add-cart-post-inner">
            <span
              className="img-pnl navigate"
              onClick={() => {
                handleShow();
              }}
            >
              <ImageSuperMarket src={getImageUrl(item.image)} />
            </span>
            <div className="txt-pnl navigate" onClick={handleCartShow}>
              <h2>{item.name}</h2>
              <p className="f-12 fw-400 mt-0">{item.description || ""}</p>
              <div className="flex-div">
                <h3>
                  <PriceBadge price={item.price} currency={currency} />
                </h3>
                <Button className="add-button">{t("Add To Cart")}</Button>
              </div>
            </div>
          </div>
        </div>
      </Zoom>

      {item && (
        <Modal
          show={show}
          className={`custom-width img v2 ${theme ? "food-modal" : ""}`}
          onHide={handleClose}
        >
          <Button className="close-btn img" onClick={handleClose}>
            <div className="close-btn-wrap"></div>
            <AiOutlineCloseCircle />
          </Button>
          <Modal.Body>
            <div className="modal-img-container v2">
              <ImageSuperMarket src={getImageUrl(item.image)} />
            </div>
          </Modal.Body>
        </Modal>
      )}

      {item && (
        <Modal
          show={showCart}
          className={`custom-width v2 ${theme ? "food-modal" : ""}`}
          onHide={handleCartClose}
        >
          <Button className="close-btn" onClick={handleCartClose}>
            <AiOutlineCloseCircle />
          </Button>
          <Form onSubmit={addToCart} key={item.id}>
            <Modal.Body>
              <div className="modal-img-container br">
                <ImageSuperMarket src={getImageUrl(item.image)} />
              </div>
              <div className="modal-text-container sub-menu">
                <div className="pl-4">
                  <h2>{item.name}</h2>
                  <h6 style={{fontSize:'10px', fontWeight:400}}>
                    {item.description ? item.description : ""}
                  </h6>
                </div>
                <div className="price-container px-4 pt-2 pb-3">
                  <p>
                    <Price price={item.price} currency={currency} />
                  </p>
                  <div className="count-order-amount">
                    <Button className="small" onClick={handleIncrease}>
                      <i className="fa fa-minus"></i>
                    </Button>
                    <p>{count}</p>
                    <Button className="small" onClick={handleDecrease}>
                      <i className="fa fa-plus"></i>
                    </Button>
                  </div>
                </div>
                <div className="px-4 pb-3">
                  <Form.Label style={{ width: "100%" }}>
                    <div
                      className="extras-heading d-flex align-items-center mb-0 m-0 pt-o text"
                      style={{
                        cursor: "pointer",
                        width: "100%",
                        color: theme ? "white" : "black",
                        fontSize: "9px",
                      }}
                    >
                      {t("Comment")}
                    </div>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder={t("Write your comment")}
                  />
                </div>
                <div className="full-div padd-div mt-4">
                  <Button
                    type="submit"
                    className="reg-btn big w-100 flex-div"
                    disabled={loading}
                  >
                    <div>
                      <i className="fa fa-plus-square mx-2"></i>
                      {t("Add To Cart")}
                    </div>
                    <div>
                      <Currency currency={currency} />
                      <span className="fw-600">
                        {parseFloat(item.price * count).toFixed(2)}
                      </span>
                    </div>
                  </Button>
                </div>
              </div>
            </Modal.Body>
          </Form>
        </Modal>
      )}
    </>
  );
}

export default InStayShopCartPost;
